var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"title"},[_vm._v("TODO")]),_c('toggleTheme',{on:{"toggle-theme":function($event){return _vm.$emit('toggle-theme')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }